import React, { useState, useEffect } from "react";
import classes from "../../App.module.css";
import OfflineDb from "../../db";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { withTranslation, Trans, useTranslation } from "react-i18next";
import swal from "sweetalert";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FooterMenu from "../../component/layout/FooterMenu";
import PeopleIcon from "@material-ui/icons/People";

function ContactTaskList() {
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null);
  const [programData, setprogramData] = useState(null);
  const { t } = useTranslation();
  const history = useHistory();

  const [customfieldobj, setcustomfieldobj] = useState(null);

  const [tbTretmentInitiationStageId, setTBTretmentInitiationStageId] =
    useState(false);
  const [advancedinvestigationsStageId, setadvancedinvestigationsStageId] =
    useState(null);
  const [treatmentinitiationformStageId, settreatmentinitiationformStageId] =
    useState(null);
  const [initialassessmentStageId, setinitialassessmentStageId] =
    useState(null);

  //once user bco is set call getContactList function

  const getTaskListData = () => {};

  async function getMetaData() {
    let metadata = await OfflineDb.getDataFromPouchDB("metaData");
    setprogramData(metadata.data);

    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);
  }

  useEffect(() => {
    getMetaData();
  }, []);

  useEffect(() => {
    if (
      programData &&
      programData.programs[0] &&
      programData.programs[0].programStages
    )
      getCustomVariableIds();
  }, [programData]);

  function getCustomVariableIds() {
    let tempobj = {};

    programData.programs[0].programStages.map((stage) => {
      let stageName = stage.description ? stage.description : stage.displayName;

      if (stageName.trim() == "TB Treatment Initiation") {
        setTBTretmentInitiationStageId(stage.id);
        tempobj = { ...tempobj, ["tbTretmentInitiationStageId"]: stage.id };
      }

      if (stageName.trim() == "Advanced Investigations") {
        setadvancedinvestigationsStageId(stage.id);
        tempobj = { ...tempobj, ["advancedinvestigationsStageId"]: stage.id };
      }
      if (stageName.trim() == "Treatment initiation form") {
        settreatmentinitiationformStageId(stage.id);
        tempobj = { ...tempobj, ["treatmentinitiationformStageId"]: stage.id };
      }
      if (stageName.trim() == "Initial Assessment") {
        setinitialassessmentStageId(stage.id);
        tempobj = { ...tempobj, ["initialassessmentStageId"]: stage.id };
      }
    });

    setcustomfieldobj(tempobj);
  }

  return (
    <div className="certi-patientpage">
      <FooterMenu></FooterMenu>
      <Grid container className="certi-patientpagediv contacttask">
        <br />
        <Grid container className="journeyDiv">
          <Grid xs="12" md="4" className="journeyDivinner">
            <div
              className="journeyItems"
              onClick={() =>
                history.push("/layout/tasklistupdated", {
                  title: "Patients waiting for Initial Assessment",
                  stageId: initialassessmentStageId,
                })
              }
            >
              <div className="clientBox">
                <PeopleIcon></PeopleIcon>
              </div>

              {/* <Typography variant='h6'>
                    {t("Contacts waiting for TB Screening")}
                </Typography> */}
              <Typography variant="h6">
                {t("Patients waiting for Initial Assessment")}
              </Typography>
            </div>
          </Grid>

          <Grid xs="12" md="4" className="journeyDivinner">
            <div
              className="journeyItems"
              onClick={() =>
                history.push("/layout/tasklistupdated", {
                  title: "Patients waiting for Advanced Investigations",
                  stageId: advancedinvestigationsStageId,
                })
              }
            >
              <div className="clientBox">
                <PeopleIcon></PeopleIcon>
              </div>

              <Typography variant="h6">
                {t("Patients waiting for Advanced Investigations")}
              </Typography>
            </div>
          </Grid>

          <Grid xs="12" md="4" className="journeyDivinner">
            <div
              className="journeyItems"
              onClick={() =>
                history.push("/layout/tasklistupdated", {
                  title: "Patient waiting for Treatment Initiation",
                  stageId: treatmentinitiationformStageId,
                })
              }
            >
              <div className="clientBox">
                <PeopleIcon></PeopleIcon>
              </div>

              <Typography variant="h6">
                {t("Patient waiting for Treatment Initiation")}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
export default ContactTaskList;
